import { get } from "lodash";
import { AMAZON_IDEA_STATUS } from "../../variable";
import { arrInvalid } from "../../helper";

export function isAuthorOrPicker(node, curUser, isAuthor = true) {
    const authorId = get(node, isAuthor ? "author.id" : "picker.id");
    const userId = get(curUser, "id");
    return authorId === userId;
}

export const AmazonIdeaType = {
    Data: "Data",
    "Option Dropdown": "Option Dropdown",
    Image: "Image",
};

export function isFieldHasValue(type) {
    return [AmazonIdeaType.Dropdown].includes(type);
}

export function isFieldData(type) {
    return [AmazonIdeaType.Data].includes(type);
}

export function isFieldImage(type) {
    return [AmazonIdeaType.Image].includes(type);
}

export function isFieldDropdown(type) {
    return [AmazonIdeaType["Option Dropdown"]].includes(type);
}

export const STATUSES_BADGE = {
    // [AMAZON_IDEA_STATUS.Pending]: "info",
    [AMAZON_IDEA_STATUS["Partially Completed"]]: "info",
    [AMAZON_IDEA_STATUS.Doing]: "success",
    [AMAZON_IDEA_STATUS.Denied]: "critical",
    [AMAZON_IDEA_STATUS.Done]: "success",
    [AMAZON_IDEA_STATUS.Rejected]: "critical",
    [AMAZON_IDEA_STATUS["Need Review"]]: "attention",
};

export function sortFields(fields) {
    if (arrInvalid(fields)) return fields;

    const res = [];
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (!field) {
            continue;
        }

        if (field.ordering == null) {
            field.ordering = i;
        }

        res.push(field);
    }

    return res;
}

export function isStatus(node, statuses) {
    const status = get(node, "status");
    return (statuses || []).includes(status);
}

export function getStoreIds(stores) {
    if (arrInvalid(stores)) return [];

    return Array.from(new Set(stores.map((i) => i?.id).filter(Boolean)));
}
